import {ChangeDetectionStrategy, Component, effect, inject, NgZone, signal, ViewChild} from '@angular/core';
import {AppConfigService} from '../../../../services/app-config.service';
import {SearchWidgetFiltersPageEnum} from '../../enums/search-widget-filters-page.enum';
import {SearchWidgetV3StateService} from '../../services/search-widget-v3-state.service';
import {SearchCategoriesV3Component} from '../search-categories-v3/search-categories-v3.component';

enum AnimationClass {
  CLOSED = 'closed',
  NORMAL = 'normal',
}

@Component({
  selector: 'app-search-categories-mobile-panel-v3',
  templateUrl: './search-categories-mobile-panel-v3.component.html',
  styleUrls: ['./search-categories-mobile-panel-v3.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchCategoriesMobilePanelV3Component {
  @ViewChild(SearchCategoriesV3Component) child: SearchCategoriesV3Component;
  protected SearchWidgetFiltersPageEnum = SearchWidgetFiltersPageEnum;
  protected isWidgetVisible = signal<boolean>(false);
  protected animationClass = signal<AnimationClass>(AnimationClass.CLOSED);
  protected currentPage = signal<SearchWidgetFiltersPageEnum>(SearchWidgetFiltersPageEnum.MAIN);
  private widgetState = inject(SearchWidgetV3StateService);
  public mobileCategoriesPanelOpen = this.widgetState.mobileCategoriesPanelOpen;
  private isOpeningPanel = false;

  constructor(
    public appConfigService: AppConfigService,
    private ngZone: NgZone,
  ) {
    this.currentPage.set(SearchWidgetFiltersPageEnum.MAIN);
    let previousPanelOpenValue = false;

    effect(
      () => {
        const currentValue = this.mobileCategoriesPanelOpen();
        if (currentValue !== previousPanelOpenValue) {
          previousPanelOpenValue = currentValue;
          this.handleMobileCategoriesPanelOpen(currentValue);
        }
      },
      {allowSignalWrites: true},
    );
  }

  public navigateBack(): void {
    this.child.navigateBack();
  }

  public onCloseClick(): void {
    this.closeThisPanel();
  }

  public onCurrentPageUpdated(page: SearchWidgetFiltersPageEnum): void {
    this.currentPage.set(page);
  }

  private closeThisPanel(): void {
    this.widgetState.updateMobileCategoriesPanelOpenValue(false);
  }

  private handleOpenPanel(result: boolean): void {
    if (result === false) {
      this.isOpeningPanel = false;
      this.animationClass.set(AnimationClass.CLOSED);
      this.ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          this.ngZone.run(() => {
            this.isWidgetVisible.set(false);
          });
        }, 500);
      });
    } else {
      if (this.isOpeningPanel) {
        return;
      }

      this.isOpeningPanel = true;
      this.isWidgetVisible.set(true);
      this.animationClass.set(AnimationClass.CLOSED);
      this.ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          this.ngZone.run(() => {
            this.animationClass.set(AnimationClass.NORMAL);
          });
        }, 50);
      });
    }
  }

  private handleMobileCategoriesPanelOpen(result: boolean): void {
    this.handleOpenPanel(result);
  }
}
